import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import { UploadType } from '@wix/da-shared-react/pkg/redux/uploads/types';
import { FileUploadOptions } from '@wix/da-shared-react/pkg/utils/hooks/useFileUpload';
import { MIME_CONFIG } from '@wix/da-shared-react/pkg/utils/mime';
import UploadItemButton from '@wix/da-shared-react/pkg/UploadItemButton';
import { Url } from '@wix/da-url';

import s from './OriginalsDeliveryDropZonePopup.scss';

interface Props {
  uploadParams?: FileUploadOptions['uploadParams'];
  requestClose: () => void;
  onDeviationCreated: (deviationId: number) => void;
}

const OriginalsDeliveryDropZonePopup: React.FC<Props> = ({
  uploadParams,
  requestClose,
  onDeviationCreated,
}) => {
  const { t } = useTranslation();
  const [dragOver, setDragOver] = useState(false);

  const onDragChange = useCallback(isDragging => setDragOver(isDragging), []);
  const onSuccess = useCallback(
    ({ deviationId }) => {
      onDeviationCreated(deviationId);
    },
    [onDeviationCreated]
  );

  return (
    <Modal
      isOpen
      isFullscreen
      heading={t('originals.deviationSubmit.title.create')}
      showHeaderBorder
      onRequestClose={requestClose}
    >
      <div className={cn(s['root'], dragOver && s['drag-over'])}>
        <UploadItemButton
          uploadOptions={{
            uploadType: UploadType.ORIGINALS_DELIVERY,
            uploadParams,
            acceptedMimeTypes: MIME_CONFIG.forDeviationSubmit,
            allowMultiple: false,
          }}
          className={s['upload-button']}
          dropZoneClassName={s['upload-dropzone']}
          customIcon={
            <img
              className={s['upload-icon']}
              src={Url.staticCDNLink(
                'eclipse/global/images/studio-originals.png'
              )}
              alt="Originals"
            />
          }
          ctaLabel={t('originals.uploadZone.ready.cta')}
          ctaVariant="originals-angular"
          title={t('originals.uploadZone.ready.title')}
          subtitle={t('originals.uploadZone.ready.subtitle')}
          onSuccess={onSuccess}
          onDragChange={onDragChange}
        />
      </div>
    </Modal>
  );
};

export default OriginalsDeliveryDropZonePopup;
